import { IconProps } from '@models/icons';

function ArrowLineLeft({ size, color, ...rest }: IconProps) {
  return (
        <svg width={size}
             height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest}>
            <path d="M12.5 6L6.5 14.5L12.5 23" stroke={color} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
  );
}

export default ArrowLineLeft;
